import { defineMessages } from 'react-intl';

const messages = defineMessages({
  customersPerDayNewCustomers: {
    defaultMessage: '{newCustomers} new customer {newCount, plural, one {order} other {orders}}',
    id: 'qFZlsh',
    description: 'tooltip label for new customer orders',
  },
  customersPerDayReturnCustomers: {
    defaultMessage: '{returnCustomers} returning customer {returningCount, plural, one {order} other {orders}}',
    id: '9uncJZ',
    description: 'tooltip label for returning customer orders',
  },
  itemsSoldOverTime: {
    defaultMessage: '{formatNumber} {categoryName}',
    id: 'koiATW',
    description: 'Returns category name and value for tooltip',
  },
  itemsSoldOverTimeNoSales: {
    defaultMessage: '0 items sold',
    id: 'ltjmew',
    description: 'Notifies user in tooltip that no sales were made on the selected day',
  },
  newOrdersShippedRatio: {
    defaultMessage: '{shippedCount} of {newCount} orders shipped',
    id: 'dTdS3Y',
    description: 'Tooltip message denoting ratiso of shipped orders to total orders',
  },
  numItemOverTimeItemsSold: {
    defaultMessage: '{count} {countRaw, plural, one {item} other {items}} sold',
    id: '6Fc/tk',
    description: 'items sold label used in tooltip',
  },
  numItemOverTimeTotalSales: {
    defaultMessage: '{formattedBalance} sales',
    id: 'AisaQr',
    description: 'revenue label used in tooltip',
  },
  shipmentsByAgeShippedTotals: {
    defaultMessage: '{count} {countRaw, plural, one {order} other {orders}} shipped',
    id: '9cPODG',
    description: 'Tooltip message showing number of shipped items',
  },
});

export default messages;
